"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseOptionGroupViewModel = void 0;
var _1 = require("./");
var ResponseOptionGroupViewModel = /** @class */ (function () {
    function ResponseOptionGroupViewModel(responseOptionGroup, defaultCultureCode) {
        this.responseOptionGroupId = responseOptionGroup.responseOptionGroupId;
        this.responseOptionGroupTypeId = responseOptionGroup.responseOptionGroupTypeId;
        var defaultTranslation = responseOptionGroup.translations && responseOptionGroup.translations.find(function (t) { return t.cultureCode === defaultCultureCode; });
        this.displayText = defaultTranslation ? defaultTranslation.text : responseOptionGroup.name;
        this.code = responseOptionGroup.code;
        if (responseOptionGroup.responseOptions && responseOptionGroup.responseOptions.length > 0) {
            this.responseOptions = responseOptionGroup.responseOptions.map(function (ro) { return new _1.ResponseOptionViewModel(ro, defaultCultureCode); });
        }
    }
    return ResponseOptionGroupViewModel;
}());
exports.ResponseOptionGroupViewModel = ResponseOptionGroupViewModel;
